import axios from "axios";
import { API } from "./api";

const KEY = "afae-presence";
const id = (() => {
  let v = sessionStorage.getItem(KEY);
  if (!v) {
    v = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`).slice(0, 64);
    sessionStorage.setItem(KEY, v);
  }
  return v;
})();

export const presence = { count: 1, beats: 0 };
const listeners = new Set();
const set = (c) => {
  if (typeof c !== "number") return;
  presence.count = Math.max(1, c);
  listeners.forEach((f) => f(presence.count));
};
const beat = () =>
  axios
    .post(`${API}/presence/heartbeat`, { device_id: id })
    .then((r) => {
      presence.beats++;
      set(r.data.count);
    })
    .catch(() => {});

export const refreshPresence = () => axios.get(`${API}/presence/count`).then((r) => set(r.data.count)).catch(() => {});

let started = false;
export function startPresence() {
  if (started) return;
  started = true;
  beat();
  setInterval(beat, 15000);
  window.addEventListener("pagehide", () =>
    fetch(`${API}/presence/leave`, { method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ device_id: id }) }).catch(() => {}),
  );
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && beat());
  window.__afaePresence = () => ({ ...presence });
}

export function onPresence(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
